export default __webpack_public_path__ + "static/media/home-creative-portfolio-img-04.e2f053a2.jpg";